import React, { PureComponent } from 'react';
import CommonList from '../../components/CommonLists/list';
import moment from 'moment';
import './index.less';
const columns = [
  {
    title: '网站名',
    dataIndex: 'site_name',
    key: 'site_name'
  },
  {
    title: '域名',
    dataIndex: 'domain',
    key: 'domain',
    width: '20%'
  },
  {
    title: '描述',
    dataIndex: 'des',
    key: 'des'
  }
];

@CommonList(columns, 'site')
class SiteList extends PureComponent {
  constructor() {
    super();
  }
  componentDidMount() {}

  render() {
    return <div />;
  }
}

export default SiteList;
